import { Component } from "@angular/core";
import { TopbarComponent } from "./navigation/topbar.component";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-platform",
  template: `
    <pienso-topbar />
    <div class="content">
        <router-outlet></router-outlet>
    </div>
  `,
  styles: [`:host { display: contents; } .content { display: block; overflow: hidden; flex: auto; }`],
  imports: [TopbarComponent, RouterOutlet],
})
export class PlatformComponent {}
